function makeAppConfig() {
    let date = new Date();
    let year = date.getFullYear();
    let AppConfig = {
        corporate :'Whirlpool',
        brand: 'GDPR',
        user: '',
        //appUrl: "https://35.241.185.33/sapservice",
        //appUrl: "https://qa.docs.whirlpool.com/sapservice",
        //appUrl: "https://wpgdpr.mediaagility.com/wiseservice",
        //appUrl: "https://wpgdpr.mediaagility.com/wiseserviceqa",
        //appUrl: "https://wpgdpr.mediaagility.com/sapservice",
        //appUrl: "https://qa.wp.documents.whirlpool.com/wiseservice",
        //appUrl: window.location.host.indexOf('localhost') != -1 ? "https://wpgdpr.mediaagility.com/sapservice" : window.location.protocol + "//" + window.location.host + "/sapservice/",
        appUrl: window.location.host.indexOf('localhost') != -1 ? "https://wp-documentsqa.europeanappliances.com/wiseservice" : "https://"+window.location.host + "/wiseservice",
        google_client_id: window.location.host.indexOf("qa.ka.") > -1 ?"694596506053-rlm1gvlp5us8d325gvrqursn8u3bdd3p.apps.googleusercontent.com" :
                      (window.location.host.indexOf("ka.") > -1 ? "202918189884-cg9mbcd4inppo3hr7k1puecio3kbcga9.apps.googleusercontent.com" :
                       ( window.location.host.indexOf("qa.wp.") > -1 ? "945606320598-9ulmic1nqr52m0qfbbkj070s12mk34ql.apps.googleusercontent.com" :
                           (window.location.host.indexOf("wp.") > -1 ? "651250627966-9a53gil73tcoonl0c4ffjobru01mtbtp.apps.googleusercontent.com":"945606320598-9ulmic1nqr52m0qfbbkj070s12mk34ql.apps.googleusercontent.com"))),

        year: year,
        layoutBoxed: false,                             // true, false
        navCollapsed: false,                            // true, false
        navBehind: false,                               // true, false
        fixedHeader: true,                              // true, false
        sidebarWidth: 'small',                          // small, middle, large
        theme: 'light',                                 // light, gray, dark
        colorOption: '21',                              // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
        AutoCloseMobileNav: true,                       // true, false. Automatically close sidenav on route change (Mobile only)
        productLink: ''//'https://themeforest.net/item/material-design-angular-2-admin-web-app-with-bootstrap-4/19421267'
    };

    return AppConfig;
}

export const APPCONFIG = makeAppConfig();
//google_client_id: window.location.host.indexOf('ka.') > -1 ?"694596506053-rlm1gvlp5us8d325gvrqursn8u3bdd3p.apps.googleusercontent.com" : "393355658000-ge2ndsorc4qruon7ofcqdjm6hcb5kqj9.apps.googleusercontent.com",